import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";
const StepsContext = createContext({
  goToStep: () => {
  },
  goToPreviousStep: () => {
  },
  steps: {},
  currentStepKey: ""
});
const useStepsContext = () => useContext(StepsContext);
const useCreateSteps = (stepsDefinition, initialStepKey) => {
  const firstStepKey = useMemo(() => {
    return initialStepKey || Object.keys(stepsDefinition)[0];
  }, [initialStepKey, stepsDefinition]);
  const [currentStepKey, setCurrentStepKey] = useState(firstStepKey);
  const stepHistory = useRef([]);
  const clearHistory = () => {
    stepHistory.current = [];
  };
  const goToStep = useCallback((stepKey) => {
    stepHistory.current.push(currentStepKey);
    setCurrentStepKey(stepKey);
  }, [currentStepKey]);
  const goToPreviousStep = useCallback(() => {
    const previousStep = stepHistory.current.pop();
    if (previousStep) {
      setCurrentStepKey(previousStep);
    }
  }, []);
  const steps = useMemo(() => {
    const keys = Object.keys(stepsDefinition);
    const instantiatedSteps = keys.reduce((acc, stepKey) => {
      return {
        ...acc,
        [stepKey]: stepsDefinition[stepKey]({ goToStep, goToPreviousStep })
      };
    }, {});
    return instantiatedSteps;
  }, [goToPreviousStep, goToStep, stepsDefinition]);
  const currentStep = useMemo(() => {
    const step = steps[currentStepKey];
    if (!step) {
      console.error("currentStep is undefined");
    }
    return step;
  }, [steps, currentStepKey]);
  const resetSteps = () => {
    setCurrentStepKey(firstStepKey);
    clearHistory();
  };
  const MemoizedStepsProvider = useMemo(() => function StepsProvider({ children }) {
    return /* @__PURE__ */ React.createElement(StepsContext.Provider, {
      value: {
        currentStepKey,
        goToStep,
        goToPreviousStep,
        steps
      }
    }, children);
  }, [currentStepKey, steps, goToStep, goToPreviousStep]);
  return {
    StepsProvider: MemoizedStepsProvider,
    steps,
    currentStep,
    goToStep,
    resetSteps,
    goToPreviousStep,
    clearHistory
  };
};
var useCreateSteps_default = useCreateSteps;
export {
  useCreateSteps_default as default,
  useStepsContext
};
